import { render, staticRenderFns } from "./ApplicationList.vue?vue&type=template&id=19506c3b&scoped=true&"
import script from "./ApplicationList.vue?vue&type=script&lang=js&"
export * from "./ApplicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19506c3b",
  null
  
)

export default component.exports